/**
 * Authored 3-card packages. Arena shuffles this list and offers two that still fit the deck.
 * Variants of the same `line` are never shown side by side.
 */
export type ArenaCombo = {
  id: string;
  line?: string;
  label: string;
  ids: readonly [string, string, string];
};

export const ARENA_COMBOS: readonly ArenaCombo[] = [
  {
    id: 'bagel-paladin',
    line: 'bagel',
    label: 'Bagel Cashout',
    ids: ['ziyg', 'srt3', 'b4uv'], // Everything Bagel, SRT Paladin, Swag Hunter
  },
  {
    id: 'bagel-speak',
    line: 'bagel',
    label: 'Bagel Cashout',
    ids: ['ziyg', '0gfr', 'cxaa'], // Everything Bagel, Galactic Speaker, One for All
  },
  {
    id: 'bagel-icon',
    line: 'bagel',
    label: 'Bagel Cashout',
    ids: ['ziyg', 'slg4', 'gm0p'], // Everything Bagel, Interview Icon, Soho Social
  },
  {
    id: 'bagel-beacon',
    line: 'bagel',
    label: 'Bagel Cashout',
    ids: ['ziyg', 'a1y2', 't61t'], // Everything Bagel, Support Beacon, Fika Feast
  },
  {
    id: 'behind',
    label: 'Comeback Kids',
    ids: ['fyzv', 'srt3', 'ibdm'], // Volunteer, SRT Paladin, Talos Olympics Winner
  },
  {
    id: 'seed',
    label: 'Underdog Club',
    ids: ['seed', 'fyzv', '8nll'], // Seed Planter, Volunteer, Battle Hardened
  },
  {
    id: 'tie-speak',
    label: 'Tie Breaker',
    ids: ['htci', '0gfr', 'jt0d'], // Buzz Builder, Galactic Speaker, Champion
  },
  {
    id: 'tie-deal',
    line: 'tie-speak',
    label: 'Tie Breaker',
    ids: ['srt2', 'deal', 'jt0d'], // SRT Knight, International Deal Conqueror, Champion
  },
  {
    id: 'wizard',
    label: 'Code Factory',
    ids: ['p12z', 'dr56', 'vib2'], // Gitcraft Wizard, Hackathon Participant, Vibe Legend
  },
  {
    id: 'wizard-fable',
    line: 'wizard',
    label: 'Code Factory',
    ids: ['p12z', 'fab5', '1mew'], // Gitcraft Wizard, Fab Fable 5, Jira Enthusiast
  },
  {
    id: 'ninja',
    label: 'Center Stage',
    ids: ['htci', 'perf', 'nmyu'], // Buzz Builder, Performance Ninja, The Frank
  },
  {
    id: 'ninja-knight',
    line: 'ninja',
    label: 'Center Stage',
    ids: ['srt2', 'perf', 'srt3'], // SRT Knight, Performance Ninja, SRT Paladin
  },
  {
    id: 'empty',
    label: 'Empty Pile Raid',
    ids: ['fk3y', 'tpbo', '5tgz'], // Mind the Gap, Foundational Forest, Serial Packer
  },
  {
    id: 'row',
    label: 'Full House',
    ids: ['st3p', 'rtdk', 'htci'], // Step by Step, Office Olympian, Buzz Builder
  },
  {
    id: 'row-algarve',
    line: 'row',
    label: 'Full House',
    ids: ['26vr', 'st3p', 'ag25'], // Office Junkie, Step by Step, Algarve 2025
  },
  {
    id: 'guess',
    label: 'Lucky Guess',
    ids: ['cupp', 'l1ys', 'wcup'], // Sweepstake Participant, Rolling 6s, Sweepstake Winner
  },
  {
    id: 'guess-guinness',
    line: 'guess',
    label: 'Lucky Guess',
    ids: ['ifu1', 'cupp', 'wcup'], // Guinness Master, Sweepstake Participant, Sweepstake Winner
  },
  {
    id: 'icon',
    label: 'Fast Track',
    ids: ['slg4', 'htci', 'dr56'], // Interview Icon, Buzz Builder, Hackathon Participant
  },
  {
    id: 'icon-wizard',
    line: 'icon',
    label: 'Fast Track',
    ids: ['slg4', 'p12z', '0lkm'], // Interview Icon, Gitcraft Wizard, Referral Rookie
  },
  {
    id: 'tunes',
    label: 'Triple Fun',
    ids: ['y0az', '52nh', 'ifu1'], // Tunesmith, Pet Parade Participant, Guinness Master
  },
  {
    id: 'tunes-split',
    line: 'tunes',
    label: 'Triple Fun',
    ids: ['y0az', 'dz9q', 'c9da'], // Tunesmith, Honorary Viking, Split The G
  },
  {
    id: 'pixel',
    label: 'Pixel Heist',
    ids: ['20nu', 'htci', '52nh'], // Pixel Prestige, Buzz Builder, Pet Parade Participant
  },
  {
    id: 'pixel-tunes',
    line: 'pixel',
    label: 'Pixel Heist',
    ids: ['20nu', 'y0az', '7ays'], // Pixel Prestige, Tunesmith, Cheer Leader
  },
  {
    id: 'baron',
    label: 'One Track Mind',
    ids: ['uwpa', '3tgz', '52nh'], // Badge Baron, I'm Always Down, Pet Parade Participant
  },
  {
    id: 'baron-tunes',
    line: 'baron',
    label: 'One Track Mind',
    ids: ['uwpa', 'y0az', 'ifu1'], // Badge Baron, Tunesmith, Guinness Master
  },
  {
    id: 'timekeep',
    label: 'Overtime',
    ids: ['nogh', 't4lx', 'tk16'], // Timekeeper of Truth, All Hands Timekeeper, Culture Catalyst
  },
  {
    id: 'ragster',
    label: 'Triple Rarity',
    ids: ['gcr2', 'eaze', 'pq4t'], // Ragster Riches, New Pixel, In Debt!
  },
  {
    id: 'growth',
    label: 'Talent Pipeline',
    ids: ['0lkm', 'intr', '6sj5'], // Referral Rookie, Unlocked: Full-Time, Deal Conqueror
  },
  {
    id: 'growth-royalty',
    line: 'growth',
    label: 'Talent Pipeline',
    ids: ['mgju', 'c4mp', 'bxbq'], // Talent Talisman, Campus Connector, Referral Royalty
  },
  {
    id: 'shield',
    label: 'Shielded Steal',
    ids: ['86xv', '8nll', '3tgz'], // Emerald Shield, Battle Hardened, I'm Always Down
  },
  {
    id: 'tiny-hand',
    label: 'Running On Empty',
    ids: ['keys', 'jjqu', 'eaze'], // King of the Keys, Stretch Squad, New Pixel
  },
  {
    id: 'discard',
    label: 'Hand Breaker',
    ids: ['4xjt', 'r2v8', 'hero'], // Jira Overlord, Phish Guard, My Hero!
  },
  {
    id: 'mythic-flip',
    label: 'Mythic Heist',
    ids: ['h588', 'hl4y', 'eoak'], // Event Legend, Lasagna, Oracle of Ages
  },
  {
    id: 'beacon',
    label: 'Even The Odds',
    ids: ['a1y2', 'jjqu', 'snp0'], // Support Beacon, Stretch Squad, All for One
  },
  {
    id: 'poker',
    label: 'High Stakes',
    ids: ['rt3p', 'kmr1', 'pq4t'], // Poker Shark, Key Man Risk, In Debt!
  },
  {
    id: 'swap',
    label: 'Musical Chairs',
    ids: ['21yr', 'setl', 'st3p'], // Explorer, Always Settle, Step by Step
  },
  {
    id: 'oracle',
    label: 'Fortune Teller',
    ids: ['eoak', 'mxv2', 'dr56'], // Oracle of Ages, Butter Fingers, Hackathon Participant
  },
  {
    id: 'race',
    label: 'Front Runner',
    ids: ['rac1', '6sj5', '52nh'], // Talos Racing Champion, Deal Conqueror, Pet Parade Participant
  },
  {
    id: 'unseen',
    label: 'Hidden Gems',
    ids: ['iuvn', 'gu53', 'olof'], // Hidden Talent, PBGY, Olof Approved
  },
  {
    id: 'cycle',
    label: 'Fresh Hand',
    ids: ['pq4t', 'tter', 'eaze'], // In Debt!, Token Terminator, New Pixel
  },
  {
    id: 'hack-win',
    label: 'Double Feature',
    ids: ['62ex', 'hpai', 'gu53'], // Hackathon Winner, Jet Boots, PBGY
  },
  {
    id: 'prodigy',
    label: 'Rares Only',
    ids: ['n26f', 'srt2', 'olof'], // Presenter Prodigy, SRT Knight, Olof Approved
  },
  {
    id: 'bagel-decoder',
    line: 'bagel',
    label: 'Bagel Cashout',
    ids: ['ziyg', 'shhh', 'gu8b'], // Everything Bagel, Secret Decoder, Wisdom Guardian
  },
  {
    id: 'wizard-crypto',
    line: 'wizard',
    label: 'Code Factory',
    ids: ['p12z', 'krih', 'sy7t'], // Gitcraft Wizard, Crypto Conqueror, Jira Initiate
  },
  {
    id: 'tunes-towers',
    line: 'tunes',
    label: 'Triple Fun',
    ids: ['y0az', '3mjs', 'sgrd'], // Tunesmith, Crypto Chef, Små Grodorna
  },
  {
    id: 'pixel-towers',
    line: 'pixel',
    label: 'Pixel Heist',
    ids: ['20nu', 'iced', 'xray'], // Pixel Prestige, The Ice Bath Club, Anton's Impostor
  },
  {
    id: 'baron-towers',
    line: 'baron',
    label: 'Culture Club',
    ids: ['uwpa', '1a0x', 'warm'], // Badge Baron, Interview Instructor, Warmth Warrior
  },
  {
    id: 'prodigy-towers',
    line: 'prodigy',
    label: 'Rares Only',
    ids: ['n26f', 'uv79', 'mmac'], // Presenter Prodigy, Gitcraft Archmage, Merge Machine
  },
  {
    id: 'timekeep-takedown',
    line: 'timekeep',
    label: 'Legendary Lockout',
    ids: ['nogh', 'bbtw', 'tk16'], // Timekeeper of Truth, Talos Takedown, Culture Catalyst
  },
  {
    id: 'mythic-pipe',
    label: 'Road To Mythic',
    ids: ['nnm0', 'om4e', 'h588'], // Event Enthusiast, Event Maestro, Event Legend
  },
  {
    id: 'quiz-wipe',
    label: 'Everyone Is Common',
    ids: ['pquw', 'rtdk', '56jo'], // Talos Pub Quiz Winner, Office Olympian, Orchid Odyssey
  },
  {
    id: 'culture-trade',
    label: 'Culture Clash',
    ids: ['coi1', 'cxaa', 'rw0q'], // Golden Handoff, One for All, Social Butterfly
  },
  {
    id: 'burn-deck',
    label: 'Bottom Of The Deck',
    ids: ['zuoo', '7y79', '2j0v'], // Talent Magnate, Founder Homage Trail, Flaky Test Martyr
  },
  {
    id: 'from-behind',
    label: 'Comeback Crew',
    ids: ['mh96', 'fyzv', 'mx26'], // Tech Trailblazer, Volunteer, Riviera Maya 2026
  },
  {
    id: 'bounce-house',
    label: 'Bounce House',
    ids: ['gu8b', 'nwqw', 'iqzd'], // Wisdom Guardian, Out of Office, Red Stapler
  },
  {
    id: 'clear-board',
    label: 'Clean Sweep',
    ids: ['ayyc', 'jdoi', 'bpzs'], // Support Star, On-Call Oracle, Talos Badges QA Specialist
  },
  {
    id: 'fun-behind',
    label: 'Fun Comeback',
    ids: ['ao8z', 'pqup', 'lvrp'], // The Road Runner, Talos Pub Quiz Participant, Good Darts!
  },
  {
    id: 'board-lead',
    label: 'Pack The Board',
    ids: ['srt1', '65ry', 'ixey'], // SRT Squire, Badger, Yeah Buddy
  },
  {
    id: 'peek-hand',
    label: 'Mind Reader',
    ids: ['bfo1', 'ao3c', '1ze3'], // Big Foot Sighting, Katz Calling, Knowledge Sharer
  },
  {
    id: 'flip-pile',
    label: 'Pile Roulette',
    ids: ['edgc', 'mxv2', 'bskt'], // Mirror Image, Butter Fingers, Blue Sky Thinking
  },
  {
    id: 'common-draw',
    label: 'Common Jackpot',
    ids: ['itit', 'n0w4', 'ixey'], // IT: You're In, Interview Initiate, Yeah Buddy
  },
  {
    id: 'jedi',
    label: 'Field Promotion',
    ids: ['q6ss', 'bost', 'ixey'], // Junior Jedi, Bostonian, Yeah Buddy
  },
  {
    id: 'filter-draw',
    label: 'Cherry Pick',
    ids: ['tele', 'a4jq', 'n0w4'], // Teletooled, Katz Fishhook Survivor, Interview Initiate
  },
  {
    id: 'herd',
    line: 'empty',
    label: 'Shut The Door',
    ids: ['cthr', 'tpbo', '5tgz'], // Cat Herder, Foundational Forest, Serial Packer
  },
  {
    id: 'boost-lock',
    line: 'empty',
    label: 'Power Lock',
    ids: ['x7tl', 'cthr', '5tgz'], // SRT Distributooor, Cat Herder, Serial Packer
  },
  {
    id: 'lock-table',
    label: 'Lock The Board',
    ids: ['cthr', 'bbtw', 'jdoi'], // Cat Herder, Talos Takedown, On-Call Oracle
  },
  {
    id: 'cheer',
    label: 'Commons Party',
    ids: ['7ays', 'ixey', 'htci'], // Cheer Leader, Yeah Buddy, Buzz Builder
  },
  {
    id: 'cheer-sky',
    line: 'cheer',
    label: 'Commons Party',
    ids: ['7ays', 'bskt', 'eaze'], // Cheer Leader, Blue Sky Thinking, New Pixel
  },
  {
    id: 'boots-ninja',
    line: 'ninja',
    label: 'Center Stage',
    ids: ['hpai', 'perf', 'htci'], // Jet Boots, Performance Ninja, Buzz Builder
  },
  {
    id: 'neighbors',
    label: 'Good Neighbors',
    ids: ['mx26', 'htci', 'st3p'], // Riviera Maya 2026, Buzz Builder, Step by Step
  },
  {
    id: 'reveal-plan',
    label: 'Power Surge',
    ids: ['x7tl', 'tk16', 'htci'], // SRT Distributooor, Culture Catalyst, Buzz Builder
  },
  {
    id: 'prodigy-lock',
    line: 'prodigy',
    label: 'Rares Only',
    ids: ['n26f', 'bbtw', 'olof'], // Presenter Prodigy, Talos Takedown, Olof Approved
  },
];
